import { formatDateHuman } from "../date-utils";
export const reportmagazineDtoFields = [{
        name: "name",
        title: "Ragione sociale",
        render: (record) => record.nome
    }, {
        name: "tipo",
        title: "Tipologia",
        render: (record) => record.tipo
    }, {
        name: "indirizzo",
        title: "Indirizzo",
        render: (record) => record.indirizzo
    }, {
        name: "comune",
        title: "Comune",
        render: (record) => record.comune
    }, {
        name: "provincia",
        title: "Provincia",
        render: (record) => record.provincia
    }, {
        name: "cap",
        title: "Cap",
        render: (record) => record.cap
    }, {
        name: "partitaiva",
        title: "P.IVA",
        render: (record) => record.piva
    }, {
        name: "cf",
        title: "Cod. Fiscale",
        render: (record) => record.codicefiscale
    }, {
        name: "datacrib",
        title: "Data agg. CRIBIS",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.cribAggiornamento)
    }, {
        name: "magazine",
        title: "Magazine",
        render: (record) => record.magazine == null ? "" : record.magazine
    }];
